import { Star, Users } from "lucide-react";
import React, { useMemo } from "react";
import "./index.css";
import BundleService from "./BundleService";

export default function BundleCard(props) {
  const { item, onClick, isSelected, className } = props;

  const { price, discountedPrice, savings, items } = useMemo(() => {
    const price = parseFloat(item.price).toFixed(2);
    const discountedPrice = parseFloat(item.discountedPrice).toFixed(2);
    const savings = (
      parseFloat(item.price) - parseFloat(item.discountedPrice)
    ).toFixed(2);
    const items = item.packageItems.filter((el) => el.visibilityForm);

    return {
      price,
      discountedPrice,
      savings,
      items,
    };
  }, [item]);

  return (
    <div className={`bundle-card ${item.colorStyle} ${className}`}>
      {item.mostPopular && <div className="most-popular">Più popolare</div>}

      <div className="card-header">
        {item.image && <img src={item.image} />}
        <h3>{item.title}</h3>
        {item.subtitle && (
          <h4 dangerouslySetInnerHTML={{ __html: item.subtitle }} />
        )}
        <p dangerouslySetInnerHTML={{ __html: item.description }} />
      </div>

      <div>
        <div className="social-proof">
          <p className="rating">
            <Star /> {item.rating}
          </p>
          <p className="purchased">
            <Users /> {item.purchaseNumber}+ acquisti
          </p>
        </div>
        <div className="additionals">
          {item.promotionalLabel && (
            <p className="additional">
              <span>{item.promotionalLabel}</span>
            </p>
          )}
          {item.additionalPromotionalLabel && (
            <p className="additional">
              <span>{item.additionalPromotionalLabel}</span>
            </p>
          )}
        </div>
      </div>

      <div className="discount-badge">Risparmia {item.discount}</div>

      <div className="price-wrapper">
        <div className="price">€{discountedPrice}</div>
        <div className="original-price">€{price}</div>
        <div className="savings">-€{savings}</div>
      </div>

      <div className="included-services">
        <h4>Servizi inclusi:</h4>
        {items.map((item, i) => {
          return (
            <BundleService key={`bundle-item-${item.id}-${i}`} service={item} />
          );
        })}
      </div>

      <button onClick={onClick} className="select-button">
        {isSelected ? "Deseleziona pacchetto" : "Seleziona pacchetto"}
      </button>
    </div>
  );
}
